define('DefaultFacetSelection'
,   [
		'DefaultFacetSelection.ShowOutOfStock.View'
	,	'custom_facets_faceted_navigation.tpl'
	,	'Utils'
	,	'underscore'
	]
,   function (
		DefaultFacetSelectionShowOutOfStockView
	,	custom_facets_faceted_navigation_tpl
	,	Utils
	,	_
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var defaultFacetID = container.getConfig().get('defaultFacetSelected.facetID')
			,	defaultFacetValue = container.getConfig().get('defaultFacetSelected.facetValue');

			try {
				var FacetBrowseView = Utils.requireModules('Facets.Browse.View')
				,	FacetsFacetedNavigationView = Utils.requireModules('Facets.FacetedNavigation.View');

				FacetBrowseView = _.has(FacetBrowseView, 'FacetBrowseView') ? FacetBrowseView['FacetBrowseView'] : FacetBrowseView;
				FacetsFacetedNavigationView = _.has(FacetsFacetedNavigationView, 'FacetsFacetedNavigationView') ? FacetsFacetedNavigationView['FacetsFacetedNavigationView'] : FacetsFacetedNavigationView;

				if(FacetBrowseView && FacetsFacetedNavigationView){
					_.extend(FacetBrowseView.prototype, {
						/**
						 * Wraps the native initialize method to set/unset a default facet based on user input.
						 * @method initialize
						 * @param {Object} options
						 */
						initialize: _.wrap(FacetBrowseView.prototype.initialize, function(fn){
							fn.apply(this, _.toArray(arguments).slice(1));
							
							var userPreferrence = (sessionStorage || window.sessionStorage).getItem('showOutOfStockItems');

							if(!userPreferrence){
								var translator = this.translator.cloneForFacetId(defaultFacetID, defaultFacetValue);
								this.model.options.data = _.extend(translator.getApiParams(), this.translator.getApiParams());
							}
						})
					});

					_.extend(FacetsFacetedNavigationView.prototype, {
						template: custom_facets_faceted_navigation_tpl
						
					,	childViews: _.extend(FacetsFacetedNavigationView.prototype.childViews || {}, {
							'ShowOutOfStockItems': function(){
								return new DefaultFacetSelectionShowOutOfStockView({
									application: this.options.application || container
								,	facetID: defaultFacetID
								,	facetValue: defaultFacetValue
								,	translator: this.options.translator
								});
							}
						})
					});
				}
			} catch (error) {
				console.log(error);
			}
		}
	};
});
